/* Scroll reveals for anything below the first screen, staggered per section.
   Content stays visible if this never runs, and in the theme editor. */
(() => {
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SEL = [
    'h1', 'h2', 'h3', '.rte > p', 'product-card', '.cro-assure__point', '.cro-assure__promise',
    '.cro-assure__q', '.collection-card', 'img'
  ].join(',');

  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (!e.isIntersecting) continue;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  const counts = new WeakMap();
  const prepare = (el) => {
    if (el.dataset.croReveal !== undefined) return;
    if (el.closest('header, footer, .cro-offer, .cro-dispatch, dialog, [hidden], slideshow-slide:not([aria-hidden="false"])')) return;
    if (el.tagName === 'IMG' && (el.closest('product-card') || el.width < 120)) return;
    const top = el.getBoundingClientRect().top;
    if (top < innerHeight) return; // never hide what is already on screen
    const section = el.closest('.shopify-section') || document.body;
    const n = counts.get(section) || 0;
    counts.set(section, n + 1);
    el.style.setProperty('--cro-delay', `${Math.min(n % 8, 6) * 70}ms`);
    el.dataset.croReveal = '';
    io.observe(el);
  };

  const scan = (scope) => scope.querySelectorAll(SEL).forEach(prepare);

  const start = () => {
    const main = document.querySelector('main');
    if (!main) return;
    root.classList.add('cro-js');
    scan(main);

    // Hero picture: a slow settle from a slight zoom
    if (!reduce) {
      const first = main.querySelector('.shopify-section');
      const media = first && first.querySelector('img, video');
      if (media && media.getBoundingClientRect().top < innerHeight) {
        if (media.parentElement) media.parentElement.style.overflow = 'hidden';
        media.classList.add('cro-settle');
      }
    }

    // Cards added later (infinite scroll, recommendations)
    new MutationObserver((list) => {
      for (const m of list) m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (n.matches?.(SEL)) prepare(n); scan(n); } });
    }).observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Long product descriptions: show the opening lines, expand on request. */
(() => {
  const setup = () => {
    document.querySelectorAll('.product-details .rte[class*="product_description"]').forEach((el) => {
      if (el.dataset.croClamp !== undefined || el.scrollHeight < 260) return;
      el.dataset.croClamp = '';
      el.classList.add('cro-clamp');
      const id = el.id || (el.id = 'cro-desc-' + Math.random().toString(36).slice(2, 8));
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cro-more';
      btn.setAttribute('aria-controls', id);
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read the full description';
      el.after(btn);
      btn.addEventListener('click', () => {
        const open = el.classList.toggle('is-open');
        el.style.maxHeight = open ? el.scrollHeight + 'px' : '';
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show less' : 'Read the full description';
        if (!open) el.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
